function cov_29g7ra50xs() {
  var path = "/app/src/utils/get-lang-and-locale.ts";
  var hash = "1a64344dc1c915cfc5d58e4d633503b99f041ada";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-lang-and-locale.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 32
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 15,
          column: 3
        }
      },
      "2": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 69
        }
      },
      "3": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 77
        }
      },
      "4": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 62
        }
      },
      "5": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 32
          },
          end: {
            line: 5,
            column: 33
          }
        },
        loc: {
          start: {
            line: 5,
            column: 66
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 8,
            column: 69
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 10,
            column: 77
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 12,
            column: 62
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 14,
            column: 18
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 26
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 14
          }
        }, {
          start: {
            line: 9,
            column: 18
          },
          end: {
            line: 9,
            column: 26
          }
        }],
        line: 9
      },
      "3": {
        loc: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 15
          }
        }, {
          start: {
            line: 11,
            column: 19
          },
          end: {
            line: 11,
            column: 27
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1a64344dc1c915cfc5d58e4d633503b99f041ada"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_29g7ra50xs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_29g7ra50xs();
import { getLangCode } from 'src/utils/get-lang-code';
import { getLocale } from 'src/utils/get-locale';
cov_29g7ra50xs().s[0]++;
export var getLangAndLocale = function getLangAndLocale(lang, locale) {
  cov_29g7ra50xs().f[0]++;
  cov_29g7ra50xs().s[1]++;
  switch (true) {
    case (cov_29g7ra50xs().b[1][0]++, !!lang) && (cov_29g7ra50xs().b[1][1]++, !locale):
      cov_29g7ra50xs().b[0][0]++;
      cov_29g7ra50xs().s[2]++;
      return {
        lang: lang,
        locale: getLocale(lang)
      };
    case (cov_29g7ra50xs().b[2][0]++, !lang) && (cov_29g7ra50xs().b[2][1]++, !!locale):
      cov_29g7ra50xs().b[0][1]++;
      cov_29g7ra50xs().s[3]++;
      return {
        lang: getLangCode(locale),
        locale: locale
      };
    case (cov_29g7ra50xs().b[3][0]++, !!lang) && (cov_29g7ra50xs().b[3][1]++, !!locale):
      cov_29g7ra50xs().b[0][2]++;
      cov_29g7ra50xs().s[4]++;
      return {
        lang: lang,
        locale: locale
      };
    default:
      cov_29g7ra50xs().b[0][3]++;
      cov_29g7ra50xs().s[5]++;
      return null;
  }
};